import type {WorkspaceModelType} from "@stores/WorkspaceStore";
import type {RootStoreModel} from "@stores/RootStore";


import {screenSizeProvider} from "@stores/ScreenSizeProvider";


export const selectItem = (rootStore: RootStoreModel, selectedId: string) => {
    const workspace = rootStore.view.workspace!;
    const selectedItem = workspace.items.get(selectedId)!;
    if (selectedItem === undefined) {
        return;
    }
    const selectedLibraryId = workspace.findLibraryIdForItem(selectedId);
    if (selectedLibraryId) {
        workspace.setSelectedLibraryId(selectedLibraryId);
    }
    if (selectedItem.getParentPaths().length > 0) {
        for (const firstPathAncestorId of selectedItem.getParentPaths()[0]) {
            const firstPathAncestor = workspace.items.get(firstPathAncestorId)!;
            firstPathAncestor.setExpanded(true);
        }
    }
    workspace.setScrollIntoViewId(selectedId);
    selectItemPlain(rootStore, workspace, selectedId);
}

export const selectItemPlain = (rootStore: RootStoreModel, workspace: WorkspaceModelType, selectedId: string | null) => {
    if (selectedId) {
        const selectedLibraryId = workspace.findLibraryIdForItem(selectedId);
        if (selectedLibraryId) {
            workspace.setSelectedLibraryId(selectedLibraryId);
        }
    }
    rootStore.view.openPageByName('docEdit', {id: selectedId ? selectedId : undefined});
    const selectedItem = selectedId ? workspace.items.get(selectedId) : null;
    if (!selectedId || selectedItem?.isCluster || selectedItem?.isLibrary) {
        rootStore.setRightMenu('');
    }
    const isMobile = screenSizeProvider.view !== 'desktop';
    if (isMobile) {
        rootStore.toggleIsTreeCollapsed(true);
    }
}
